import Modal from "react-bootstrap/Modal";
import { togglePlanSection } from "../../../../../actions/show_modal_Action";
import { useDispatch } from "react-redux";
import { MediaBaseUrl } from "../../../../../actions/api";
import { Button } from "react-bootstrap";

const UpgradePopUp = (props) => {

  const dispatch = useDispatch();

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal fade modal-overflow upgrade-plan"
    >
      <div className="modal-content">
        <div className="modal-header border-0 pb-0">
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-hidden="true" onClick={props.onHide}>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12">
              <div className="upgredeMain text-center">
                <div className="Erroricon" style={{ display: 'none' }}><span className=""></span></div>
                <div className="Errorimage pb-3" ><img src={`${MediaBaseUrl}error/add-more-walls-error.png`} className="img-fluid" width={500} height={300} alt="Upgrade Plan" /></div>
                <div className="permissionMsg my-4 px-4">
                  <h4 className="ErrorMsg">Add More Walls</h4>
                  <p className="msgSec">You have reached the maximum limit of Walls. Add more walls to your plan for a seamless experience.</p>
                </div>
                <div className="buttonUpgred mb-3">
                  <Button variant="primary" id="addonFeaturesScroll" className="commanBtn px-5" onClick={props.onClickUpgrade}>
                    Upgrade Now
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UpgradePopUp;
